import { spacing } from '@lamimed/pantheon';
import styled from 'styled-components';

export const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 0 ${spacing.medium} 0;
`;
